import { HelpersType, cdn, helpers, httpMethods } from "./common";

const development: HelperConstantsType = {
  api: {
    url: "http://localhost:3000/api/v1",
    url_new: "http://localhost:3000/api",
    version: "/v1",
  },
  httpMethods,
  ...cdn,
  helpers: helpers.testnet,
};

const staging: HelperConstantsType = {
  api: {
    url: "/api",
    url_new: "https://lending.test.bit5.com/api",
    version: "/v1",
  },
  httpMethods,
  ...cdn,
  helpers: helpers.testnet,
};

const production: HelperConstantsType = {
  api: {
    url: "https://bit5uitest-58d4p.ondigitalocean.app/api",
    url_new: "https://lending.bit5.com/api",
    version: "/v1",
  },
  httpMethods,
  ...cdn,
  helpers: helpers.mainnet,
};

const constantArr = {
  development,
  staging,
  production,
};

export const helperConstants =
  constantArr[process.env.NEXT_PUBLIC_ENV_VARIABLE];

export const getNftImageFromCDN = ({
  isDNFT,
  collectionInfo,
  tokenId,
  imageFtpPath,
  metadata,
  imagesize = "detail",
}: {
  isDNFT: boolean;
  collectionInfo: any;
  tokenId: any;
  imageFtpPath: any;
  metadata: any;
  imagesize?: string;
}) => {
  let image = "";
  if (isDNFT) {
    image = collectionInfo.api + tokenId;
  } else {
    image = imageFtpPath
      ? helperConstants.cdn.path +
        imageFtpPath +
        helperConstants.cdn[imagesize] +
        helperConstants.cdn.version
      : JSON.parse(metadata)?.image;
  }

  return image;
};

export type HelperConstantsType = {
  api: {
    url: string;
    url_new: string;
    version: string;
  };
  httpMethods: {
    get: string;
    post: string;
    put: string;
    delete: string;
  };
  cdn: {
    path: string;
    detail: string;
    thumbnail: string;
    w350x192: string;
    w1920x1080: string;
    w100: string;
    w560: string;
    w200: string;
    version: string;
  };
  cloudinary: {
    path: string;
  };
  helpers: HelpersType;
};
